import React from 'react'

function Overview() {
    return (
        <div class="idocs-content">
            <div class="row">
      <div class="col-md-12">
         <div style={{ color: "#fff !important", backgroundColor: "#263f91", height: "350px" }}>
         <h1 class="banner-text" style={{}}>
            Welcome<br />
            to Safexpay<br />
            Documentation
         </h1>
         <p style={{ color: "#fff", float: "left", paddingLeft: "140px", marginTop: "10px" }}>
         Welcome to the Safexpay developer documentation. <br />
         You will find help about safexpay products and APIs <br />
         that will help you start using our products quickly.
         </p>
         <img src={process.env.PUBLIC_URL + '/images/Arrow-Green.png'} alt="logo" style={{width: "21%" , 
         float: "right" , top: "5%", right: "20%", position: "absolute"}}/>
      </div>
   </div>
</div>
            <div class="container">
            
                <div class="row">
                    <div class="col-md-8">
                        <section id="idocs_content">
                            <h1>Overview</h1>
                            <hr />
                            <p class="mt-30">At SafexPay, we began by offering digital payment solutions to businesses. But we soon realized that we couldn't reach everyone on our own. That's why we created a white-label payment aggregation platform in 2018, which other companies can use to get into digital payments globally.
                        </p>
                        <p>
                           Our platform is now the leader in the industry, with multiple companies worldwide benefiting from our experience and expertise. In 2019, we started focusing on specific use cases, such as housing societies, email, SMS & QR payment collection links, quick enrollment with merchants through our form builder, and subscription payments. We are committed to making digital payments accessible to everyone.
                        </p>
                        </section>
                        
                    </div>
                    <div class="col-md-4">
                        
                    </div>
                </div>



                

            </div>
        </div>

    )
}

export default Overview